import { FC, Fragment, useCallback } from "react";
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { HierarchyViewDuplicateActionDialog } from "./HierarchyViewDuplicateActionDialog";
import { useViewsHierarchyContext } from "../../ViewsHierarchyProvider";
import { getUserPermissionInfoText } from "../../../../../utils/helpers/getUserPermissionInfoText";
import { useDialog } from "@/utils/hooks/useDialog.hook";

interface HierarchyViewDuplicateActionProps {
  onClose(): void;
  viewId: string;
  viewName: string;
}

export const HierarchyViewDuplicateAction: FC<
  HierarchyViewDuplicateActionProps
> = ({ viewId, onClose, viewName }) => {
  const { open, openDialog, closeDialog } = useDialog();

  const { actions } = useViewsHierarchyContext();
  const disabled = actions.viewDuplicate.disabled;

  const closeHandler = useCallback(() => {
    closeDialog();
    onClose();
  }, [onClose, closeDialog]);

  return (
    <Fragment>
      <Tooltip
        arrow
        placement="right"
        title={disabled ? getUserPermissionInfoText("Duplicate view") : ""}
      >
        <span>
          <MenuItem onClick={openDialog} disabled={disabled}>
            <ListItemIcon>
              <ContentCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="body2">Duplicate</Typography>
            </ListItemText>
          </MenuItem>
        </span>
      </Tooltip>

      <HierarchyViewDuplicateActionDialog
        viewId={viewId}
        open={open}
        onClose={closeHandler}
        viewName={viewName}
      />
    </Fragment>
  );
};
